import type { SVGProps } from 'react';

const RightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M3.75 9H14.25M14.25 9L9 3.75M14.25 9L9 14.25"
      stroke="#6366F1"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default RightIcon;
